<template>
  <div class="ForWhomForm">
    <h2 class="gl_form-title">
      {{ t('copy_life_for-whom-form_title') }}
    </h2>

    <RadioButtonGroup
      id="main"
      :value="forWhom"
      :options="forWhomOptions"
      v-model="forWhom"
    />
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import RadioButtonGroup from '@/modules/core/components/ui/RadioButtonGroupComponent.vue'
import { ForWhomEnum, UserRoleEnum } from '@/modules/core/models/enums'
import type { OptionsValuesInterface } from '@/modules/core/models/types'
import Insured from '@/modules/common/common/models/APP/Insured'
import type LifeRaterAnswers from '@/modules/life/rater/models/APP/LifeRaterAnswers'

const { t } = useI18n()

defineExpose({ triggerSubmit })
interface PropsInterface {
  nextForm: String[]
  answers: LifeRaterAnswers
}
const props = withDefaults(defineProps<PropsInterface>(), {})

const forWhomOptions: OptionsValuesInterface[] = [
  {
    label: t('rater.common.for-whom.options.me'),
    value: ForWhomEnum.ME
  },
  {
    label: t('rater.common.for-whom.options.other'),
    value: ForWhomEnum.NOT_ME
  }
]

const forWhom = ref(props.answers.forWhom)

function triggerSubmit() {
  const page = props.nextForm[0]

  const insuredData = createInsuredData()

  const answers = {
    forWhom: forWhom.value,
    forWhomPeople: 1,
    insureds: [new Insured(insuredData)]
  }

  return { page, answers }
}

function createInsuredData() {
  if (forWhom.value === ForWhomEnum.NOT_ME) {
    return {
      role: UserRoleEnum.INSURED,
      riskNumber: 2
    }
  }

  return {
    role: UserRoleEnum.HOLDER_INSURED,
    riskNumber: 1
  }
}
</script>

<style lang="scss" scoped>
.ForWhomForm {
  .RadioButtonGroupComponent {
    margin-bottom: $spacing-l;

    :deep(.ErrorMessageComponent) {
      display: none;
    }
  }
}
</style>
